export default "__VITE_ASSET__e7c2e5ea__"